export default "__VITE_ASSET__eba3bf25__"